exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_item[data-v-91594144]{position:relative;width:310px;height:110px;padding:10px;margin-bottom:10px;margin-right:10px;border:1px solid #eeeeee}.goods_item.active[data-v-91594144]{border:1px solid #2993ff}.goods_item .check_icon[data-v-91594144]{position:absolute;top:0;right:0;z-index:3}.goods_item .el-image[data-v-91594144]{margin-right:10px;width:90px;height:90px}.goods_item .goods_title[data-v-91594144]{color:#666666}.goods_item .goods_id[data-v-91594144]{color:#999999;margin-top:10px}.checked_wrap[data-v-91594144]{width:350px;padding:10px;max-height:560px;overflow:auto;border-left:1px solid #eeeeee}\n", ""]);

// exports
